<template>
    <div class="p-1" :class="sizeClassObject" @dragstart="onDragStart">
        <div class="card-header">
            <div>
                <i v-if="panel.isEligiblePanel !== true" class="far fa-edit float-right text-primary pointer" @click="showSizePrompt"></i>
            </div>
            <div>
                {{ isEnVersion ? panel.labelEn : panel.label }}
            </div>
            <vs-prompt class="vs-lg"
                    :title="$t('dynamicLayout.editPanelSize')"
                    :accept-text="$t('buttons.ok')"
                    :cancel-text="$t('buttons.cancel')"
                    :active.sync="activePrompt"
                    :is-valid="isValidPanelSize"
                    @accept="acceptPrompt"
                    @cancel="cancelPrompt"
                    @close="cancelPrompt"
                    color="primary">
                <vs-input :label="$t('dynamicLayout.size')" type="number" min="1" max="12" v-model="panel.size" />
                <span class="text-danger" v-if="!isValidPanelSize">{{ $t('dynamicLayout.enterValidValue') }}</span>
            </vs-prompt>
        </div>
    </div>
</template>

<script>
    import { Culture, DynamicLayoutPageSize } from '../../models/enums';

    export default {
        props: {
            panel: Object,
        },
        components: {

        },
        data() {
            return {
                activePrompt: false,
                originalSize: this.panel.size,
            }
        },
        computed: {
            isValidPanelSize() {
                return this.panel.size >= this.MinDynamicLayoutPageSize && this.panel.size <= this.MaxDynamicLayoutPageSize;
            },
            sizeClassObject: function () {
                var result = {};
                for (var size = this.MinDynamicLayoutPageSize; size <= this.MaxDynamicLayoutPageSize; size++) {
                    result['col-md-' + size + ' col-sm-' + size] = (size === this.panel.size);
                }
                return result;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            MinDynamicLayoutPageSize() {
                return DynamicLayoutPageSize.Min;
            },
            MaxDynamicLayoutPageSize() {
                return DynamicLayoutPageSize.Max;
            }
        },
        methods: {
            showSizePrompt(event) {
                this.activePrompt = true;
            },
            cancelPrompt() {
                this.panel.size = this.originalSize;
            },
            acceptPrompt() {
                this.originalSize = this.panel.size;
            },
            onDragStart(event) {
                event.dataTransfer.setData("Panel", event.target.innerText);
            }
        }
    }
</script>


<style scoped>
    .card-header {
        padding: .75rem 1.25rem;
        margin-bottom: 0;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, .12);
    }

    .card-header:first-child {
        border-radius: calc(.125rem - 1px) calc(.125rem - 1px) 0 0;
    }
</style>

